






















































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Getter } from 'vuex-class';
import VuetableMixin from '@/mixins/vuetable';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import DatatableHeading from '@/components/piaf/Datatable/DatatableHeading.vue';
import VuetablePaginationBootstrap from '@/components/piaf/Common/VuetablePaginationBootstrap.vue';
import { getRoleById, roleIsHigherThen } from '@/utils/role';
import { AdminRoleList } from '@/configs/role';
import { getAdminList, postActiveStatus, deleteAdmin } from '@/configs/api-path';
import { AdminListItem } from '@/models/admin';
import { UserLogin } from '@/models/user';
import { VuetableSortOrder, VuetablePagination } from '@/@types/vuetable.d';

@Component({
  components: {
    DatatableHeading,
    VuetablePaginationBootstrap,
  },
})
export default class PageAdminList extends mixins(
  VuetableMixin, ApiStatusMixin, ApiErrorMixin,
) {
  $refs!: {
    vuetable: any;
    pagination: any;
  }

  tableCss = {
    tableClass: 'table-divided order-with-arrow',
  }

  tablePrepage = 10;

  dataTableFields: any[] = [
    {
      name: 'name',
      title: '姓名',
      sortField: 'name',
      dataClass: 'list-item-heading',
    },
    {
      name: 'role',
      sortField: 'role',
      title: '帳號權限',
      width: '120px',
      formatter(value: number) {
        const role = getRoleById(value);
        return role ? role.text : 'N/A';
      },
      dataClass: 'text-muted',
    },
    {
      name: 'status--slot',
      title: '狀態',
    },
    {
      name: 'action--slot',
      title: '操作',
      width: '198px',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
  ];

  searchKeywords = '';

  adminList: AdminListItem[] = [];

  tablePagination: VuetablePagination = {
    current_page: 0,
    from: 0,
    last_page: 0,
    per_page: 0,
    to: 0,
    total: 0,
  }

  // eslint-disable-next-line class-methods-use-this
  get breadcrumb() {
    return [
      {
        text: '帳號管理',
        to: null,
      },
      // {
      //   text: '帳號列表',
      //   to: null,
      // },
    ];
  }

  get filterKeyword() {
    // Convert wildcard search. (?|*)
    return this.searchKeywords.replace(/(\?|\*)/g, '\\w');
  }

  get filtedAdminList() {
    return this.adminList
      .filter((admin) => {
        const matchRegexp = new RegExp(this.filterKeyword === '' ? '.*' : `.*(${this.filterKeyword}).*`, 'gi');

        const matchName = admin.name.match(matchRegexp);

        return Boolean(matchName);
      });
  }

  @Getter('user/currentUser') currentUser!: UserLogin;

  @Watch('filtedAdminList')
  onFiltedAdminListChange() {
    this.$refs.vuetable.refresh();
  }

  @Watch('tablePrepage')
  onTablePrepageChange() {
    if (this.vuetablePrepage !== undefined) {
      this.vuetablePrepage = this.tablePrepage;
    }
    this.$refs.vuetable.refresh();
  }

  testRoleIsHigher(roleCode: number) {
    return roleIsHigherThen((this.currentUser.role as AdminRoleList).code, roleCode);
  }

  searchChange(searchText: string) {
    this.searchKeywords = searchText;
  }

  changePageSize(size: number) {
    this.tablePrepage = size;
  }

  onPaginationData(paginationData: VuetablePagination) {
    this.$refs.pagination.setPaginationData(paginationData);
  }

  onChangePage(page: number) {
    this.$refs.vuetable.changePage(page);
  }

  dataManager(sortOrder: VuetableSortOrder[], pagination: VuetablePagination) {
    const tableData = this.vuetableDataManager(
      sortOrder, pagination, this.$refs.vuetable, this.filtedAdminList,
    );
    this.tablePagination = tableData.pagination;
    return tableData;
  }

  async fetchAdminList() {
    this.setApiLoading();
    try {
      const { data: adminListResponse } = await this.$axios.get<{
        code: number;
        admin: AdminListItem[];
      }>(getAdminList);

      if (adminListResponse.code === 0) {
        this.adminList = adminListResponse.admin;
      } else {
        this.apiErrorCodeAlert(adminListResponse.code);
        // console.error(adminListResponse.code);
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async toggleAdminStatus(nextStatus: boolean, admin: AdminListItem) {
    this.setApiLoading();
    try {
      const statusData = {
        module: 1,
        targetId: admin.id,
        status: nextStatus,
      };

      const { data: adminStatusResponse } = await this.$axios.post<{
        code: number;
      }>(postActiveStatus, statusData);

      if (adminStatusResponse.code === 0) {
        this.$notify.show('success filled', `${admin.name}已${nextStatus === true ? '啟用' : '停用'}！`, `${nextStatus === true ? '啟用' : '停用'}帳號`, { duration: 3000, permanent: false });
      } else {
        const adminInList = this.adminList.find((oAdmin) => oAdmin.id === admin.id);
        if (adminInList) {
          adminInList.status = !nextStatus;
        }
        this.apiErrorCodeAlert(adminStatusResponse.code, `${nextStatus === true ? '啟用' : '停用'}帳號`);
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async deleteAdmin(admin: AdminListItem) {
    const adminId = admin.id;
    // eslint-disable-next-line no-alert
    const confirm = window.confirm(`確定刪除 ${admin.name} ？\n刪除後將無法復原該帳號。`);

    if (confirm === false) {
      return;
    }

    this.setApiLoading();
    try {
      const { data: adminStatusResponse } = await this.$axios.delete<{
        code: number;
        user: {
          id: number;
        };
      }>(deleteAdmin(adminId));

      if (adminStatusResponse.code === 0) {
        this.$notify.show('success filled', `${admin.name}已刪除！`, '刪除帳號', { duration: 3000, permanent: false });

        const adminIndexInList = this.adminList.findIndex((oAdmin) => oAdmin.id === adminId);

        this.adminList.splice(adminIndexInList, 1);
      } else {
        this.apiErrorCodeAlert(adminStatusResponse.code, '刪除帳號');
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  beforeMount() {
    this.fetchAdminList();
  }
}
